import React, { useEffect, useState } from "react";
import versiwapicon from "../../../../../src/assets/images/Icons/icons/wap.svg";
import versiwebicon from "../../../../../src/assets/images/Icons/icons/WWW.svg";
import InformasiResultPopup from "./InformasiResultPopup";
import { useSelector, useDispatch } from "react-redux";
import { setCommonConfig, setCurrentStep } from "../../../../redux/actions.js";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import TaiwanIcon from "../../../../assets/images/Icons/Taiwan.svg";
import CambodiaIcon from "../../../../assets/images/Icons/Cambodia.svg";
import GrabpoolsIcon from "../../../../assets/images/Icons/Grabpools.svg";
import ChinaIcon from "../../../../assets/images/Icons/China.svg";
import SydneyIcon from "../../../../assets/images/Icons/Sydney.svg";
import MangoliaIcon from "../../../../assets/images/Icons/Mongolia.svg";
import SingaporeIcon from "../../../../assets/images/Icons/Singapore.svg";
import JapanIcon from "../../../../assets/images/Icons/Japan.svg";
import HongkongIcon from "../../../../assets/images/Icons/Hongkong.svg";
import NusantaraIcon from "../../../../assets/images/Icons/Nusantara.svg";
import { makeAjax, respStatus, showMessage, url } from "../../../../helpers/global_helper";
import { withTranslation } from "react-i18next";
import UseBodyScrollLock from "../../../Popups/UseBodyScrollLock.js";
import { IoMdClose } from "react-icons/io";
import CoachMarkPopup from "../../../Popups/CoachMarkPopup.js";
import CommonConfig from "../../../../redux/common-config/reducer.js";
const RightTable = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const app_type = useSelector((state) => state.CommonConfig.app_type);
  const game_sub_type = useSelector((state) => state.GameSubType.game_sub_type);
  const game_sub_child_type = useSelector((state) => state.GameSubType.game_sub_child_type);
  const country_name = useSelector((state) => state.CommonConfig.country_name);

  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const subGameType = useSelector((state) => state.CommonConfig.subGameType);

  const gameType = useSelector((state) => state.CommonConfig.gameType) ?? "4d3d2d";
  const { game_code } = useParams();
  const [discountPrize, setPrizeDiscount] = useState([]);
  const isSettingCoachMark = useSelector((state) => state.paginationData.isSettingCoachMark)
  const [isInfoResultPopup, setIsInfoResultPopup] = useState(false);
  const [last10Result, setLast10Result] = useState([]);
  const currentStep = useSelector((state) => state.paginationData.currentStep)

  UseBodyScrollLock(isInfoResultPopup);

  const openInformasiResultPopup = () => {
    setIsInfoResultPopup(true);
  };
  const closeInformasiResultPopup = () => {
    setIsInfoResultPopup(false);
  };

  const country = localStorage.getItem("activeGameId")
  const gameID = country ? country : gameId

  useEffect(() => {
    makeAjax(
      url.TOGEL_API.getResultTogel,
      { "gameId": gameId },
      url.TOGEL_MS_EXT
    ).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        showMessage(response);
        return;
      }
      setLast10Result(response.data.data);
    });
  }, [gameId, game_sub_type]);

  useEffect(() => {
    makeAjax(url.TOGEL_API.getTogelDetails, { "gameId": gameID, "gameType": gameType }).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        showMessage(response);
        return;
      }
      setPrizeDiscount(response.data);
      dispatch(setCommonConfig({ key: 'discount', value: response.data }));
      dispatch(setCommonConfig({ key: 'subGameOnOffStatus', value: response.data.subGameStatus }));
      dispatch(setCommonConfig({ key: 'marketCloseStatus', value: response.data.marketStatus }));
      dispatch(setCommonConfig({ key: 'gameBlockStatus', value: response.data.gameBlock }));
      dispatch(setCommonConfig({ key: 'allowed_games', value: response.data.allowed_games }));
      if (response.data.marketStatus == 0 || (response.data.allowed_games !== null && !response.data.allowed_games?.allowed_game_id.split(',').includes(String(gameID)))) {
        dispatch(setCurrentStep(-1))
      }
    })
  }, [gameId, gameType, subGameType])

  const countrylist = {
    "Taiwan": TaiwanIcon,
    "Grabpools": GrabpoolsIcon,
    "Cambodia": CambodiaIcon,
    "Singapore": SingaporeIcon,
    "Japan": JapanIcon,
    "China": ChinaIcon,
    "Sydney": SydneyIcon,
    "Mongolia": MangoliaIcon,
    "Hongkong": HongkongIcon,
    "Nusantara": NusantaraIcon
  };

  // const country_name = "Taiwan"; 
  const LogoComponent = countrylist[country_name];
  useEffect(() => {
    // set channel
    const userAgent = navigator.userAgent;
    const isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        userAgent
      );
    const isTablet = /iPad|Android/.test(userAgent) && !isMobile;

    let deviceType = '';
    if (isMobile || isTablet) {
      if (app_type == 'desktop') {
        deviceType = 2;
        localStorage.setItem('deviceType', deviceType);
      } else {
        deviceType = 7;
        localStorage.setItem('deviceType', deviceType);
      }
    } else {
      if (app_type == 'desktop') {
        deviceType = 1;
        localStorage.setItem('deviceType', deviceType);
      } else {
        deviceType = 6;
        localStorage.setItem('deviceType', deviceType);
      }
    }
  }, [app_type]);

  const changeAppType = () => {
    let temp_app_type = "wap";
    if (app_type == "wap") temp_app_type = "desktop";
    dispatch(setCommonConfig({ key: "app_type", value: temp_app_type }));
  };
  const clickIcon = () => {
    dispatch(setCommonConfig({ key: 'gameType', value: '4d3d2d' }))
  }

  const prize123Status = useSelector((state) => state.CommonConfig.discount.prize123Status);

  return (
    <div className="righttble_wrapper ">

      <div
        className={`${app_type === "wap" || game_sub_type === "BALAK-BALIK"
          ? "versi-web"
          : "versi-wap"
          }
           ${currentStep === 11 ? " custom-tooltip-wrapper highlighted" : ""}
           ${[2,3, 4,5].includes(currentStep) ? "z-index-negative" : ""}
        `}
        onClick={changeAppType}
      >
        {app_type === "wap" ? <img src={versiwebicon} alt="versiwebicon" className="icon" /> : <img src={versiwapicon} alt="versiwapicon" className="icon" />
        }
        {game_sub_type === "BALAK-BALIK"
          ? (app_type === "desktop" ? "Versi WAP" : "Versi WAP")
          : game_sub_type === "3DDEPAN" || game_sub_type === "TwoDDepan" || game_sub_type === "TwoDTengah" ? (app_type === "desktop" ? "Versi WAP" : "Versi WEB") : (app_type === "desktop" ? "Versi WAP" : "Versi WEB")}
        {currentStep === 11 && <CoachMarkPopup />}
      </div>
      {currentStep === 11 && <div className="custom-overlay"></div>}

      <div className={`${currentStep === 12 ? "custom-tooltip-wrapper highlighted-info" : ""}`}>
        <div className={`informasi_result  `} onClick={openInformasiResultPopup}>
          {props.t('Information_result')}
          {currentStep === 12 && <CoachMarkPopup />}
        </div>
      </div>

      {currentStep === 12 && <div className="custom-overlay"></div>}

      {window.location.pathname === "/" ||
        window.location.pathname === "/game/Four_D" ||
        window.location.pathname === "/game/Quick_Buy" ||
        window.location.pathname === "/game/Bbfs" ||
        window.location.pathname === "/game/pola_tarung" ||
        window.location.pathname === "/game/ThreeDDepan" ||
        window.location.pathname === "/game/TwoDDepan" ||
        window.location.pathname === "/game/TwoDTengah" ||
        window.location.pathname === "/game/FiveSix_D" ||
        window.location.pathname === "/game/bolak_balik" ? (
        game_sub_type === "QUICK_BUY" ? (
          <>
            <div className="Menebak_result">{props.t('discount')}</div>
            <div className="QuickBuy_Division_result">
              <div className="QuickBuy_Division_left">
                <p>4D:  <span className="righttble_bluetxt">{discountPrize.showDisc4d}%</span></p>
                <p>3D:  <span className="righttble_bluetxt">{discountPrize.showDisc3d}%</span></p>
                <p>2D:  <span className="righttble_bluetxt">{discountPrize.showDisc2d}%</span></p>
                <p>Colok Bebas:  <span className="righttble_bluetxt">{discountPrize.showDiscColokBebas}%</span></p>
                <p>Colok Bebas 2D:  <span className="righttble_bluetxt">{discountPrize.showDiscColokBebas2d}%</span> </p>
                <p>Colok Naga:  <span className="righttble_bluetxt">{discountPrize.showDiscColokNaga}%</span> </p>
                <p>Kombinasi:  <span className="righttble_bluetxt"> {discountPrize.showDiscKombinasi}%</span></p>
              </div>
              <div className="QuickBuy_Division_right">
                <p>Colok Jitu:  <span className="righttble_bluetxt">{discountPrize.showDiscColokJitu}%</span></p>
                <p>Tengah/Tepi:  <span className="righttble_bluetxt">{discountPrize.showDiscTengahTepi}%</span> </p>
                <p>5050:  <span className="righttble_bluetxt">{discountPrize.showDisc5050}%</span></p>
                <p>5050 2D:  <span className="righttble_bluetxt"> {discountPrize.showDisc50502d}%</span></p>
                <p>Shio:  <span className="righttble_bluetxt"> {discountPrize.showDiscShio}%</span></p>
                <p>Silang Homo:  <span className="righttble_bluetxt"> {discountPrize.showDiscSilangHomo}%</span></p>
              </div>
            </div>

            <div className="Menebak_result">PRIZE QUICK BUY</div>
            <div className="prize_result">
              {props.t('prize')}: 4D: <span className="righttble_bluetxt"> X {discountPrize.showMenang4d}, </span>
              {/* 3D Depan: <span className="righttble_bluetxt"> X {discountPrize.showMenang3dDepan} , </span> */}
              3D: <span className="righttble_bluetxt"> X {discountPrize.showMenang3d},</span>
              {/* 2D Depan: <span className="righttble_bluetxt"> X {discountPrize.showMenang2dDepan} ,</span> */}
              2D: <span className="righttble_bluetxt">  X {discountPrize.showMenang2dBelakang}</span>
            </div>
          </>
        ) : (
          <>
            {
              (game_sub_type === "4d3d2d" || game_sub_type === "4D3D2D") ?
                <div className="Menebak_result">{props.t('guess_exact_number')}</div>
                : game_sub_type === "3DDEPAN" ?
                  <div className="Menebak_result">{props.t('guess_exact_number_3d_depan')}</div>
                  : game_sub_type === "TwoDDepan" ?
                    <div className="Menebak_result">{props.t('guess_exact_number_2d_depan')}</div>
                    : game_sub_type === "TwoDTengah" ?
                      <div className="Menebak_result">{props.t('guess_exact_number_2d_tengah')}</div>
                      : game_sub_type === "BALAK-BALIK" ?
                        <div className="Menebak_result">{props.t('bolak_balik_text')}</div>
                        : game_sub_type === "BBFS" ?
                          <div className="Menebak_result">{props.t('BBFS_text')}</div>
                          : game_sub_type === "POLA_TARUNG" ?
                            <div className="Menebak_result">{props.t('polatarung_text')}</div>
                            : (game_sub_type === "5D6D" || game_sub_type === "5d6d") ?
                              <div className="Menebak_result">{props.t('guess_exact_number_5d6d')}</div>
                              : ""
            }
            {
              game_sub_child_type == "DISCOUNT" ?
                ((game_sub_type == "4d3d2d" || game_sub_type == "4D3D2D" || game_sub_type == "POLA_TARUNG" || game_sub_type == "BBFS") ?
                  <div className="Division_result">
                    {props.t('discount')} :
                    4D : <span className="righttble_bluetxt"> {discountPrize.showDisc4d}%, </span>
                    3D : <span className="righttble_bluetxt">{discountPrize.showDisc3d}%,</span>
                    2D : <span className="righttble_bluetxt">{discountPrize.showDisc2d}%</span>
                  </div> :
                  (game_sub_type === "3DDEPAN" ?
                    <div className="Division_result">
                      {props.t('discount')} :
                      3D : <span className="righttble_bluetxt">{discountPrize.showDisc3d}%</span>
                    </div> :
                    (game_sub_type === "TwoDDepan" ?
                      <div className="Division_result">
                        {props.t('discount')} :
                        2D : <span className="righttble_bluetxt">{discountPrize.showDisc2d}%</span>
                      </div> :
                      (game_sub_type === "TwoDTengah" ?
                        <div className="Division_result">
                          {props.t('discount')} :
                          2D : <span className="righttble_bluetxt">{discountPrize.showDisc2d}%</span>
                        </div> :
                        (game_sub_type === "5d6d" ?
                          <div className="Division_result">
                            {props.t('discount')} : 
                            6D : <span className="righttble_bluetxt"> {discountPrize.showDisc6d}%, </span>
                            5D : <span className="righttble_bluetxt">{discountPrize.showDisc5d}%</span>
                          </div> : '')))))
                : game_sub_child_type == "FULLBET" ?
                  ((game_sub_type == "4d3d2d" || game_sub_type == "4D3D2D" || game_sub_type == "POLA_TARUNG" || game_sub_type == "BBFS") ?
                    <div className="Division_result">
                      {props.t('discount')} :
                      4D : <span className="righttble_bluetxt">0%,</span>
                      3D : <span className="righttble_bluetxt">0%,</span>
                      2D : <span className="righttble_bluetxt">0%</span>
                    </div> :
                    (game_sub_type === "3DDEPAN" ?
                      <div className="Division_result">
                        {props.t('discount')} :
                        3D : <span className="righttble_bluetxt">0%</span>
                      </div> :
                      (game_sub_type === "TwoDDepan" ?
                        <div className="Division_result">
                          {props.t('discount')} :
                          2D : <span className="righttble_bluetxt">0%</span>
                        </div> :
                        (game_sub_type === "TwoDTengah" ?
                          <div className="Division_result">
                            {props.t('discount')} :
                            2D : <span className="righttble_bluetxt">0%</span>
                          </div> :
                          (game_sub_type === "5d6d" ?
                            <div className="Division_result">
                              {props.t('discount')} :
                              6D : <span className="righttble_bluetxt"> 0%, </span>
                              5D : <span className="righttble_bluetxt">0%</span>
                            </div> : '')))))
                  : game_sub_child_type == "PRIZE" ?
                    ((game_sub_type == "4d3d2d" || game_sub_type == "4D3D2D" || game_sub_type == "POLA_TARUNG" || game_sub_type == "BBFS") ?
                      <div className="Division_result">
                        {props.t('discount')} :
                        4D : <span className="righttble_bluetxt"> {discountPrize.showDisc4dPrize123 ? discountPrize.showDisc4dPrize123 : 0}%, </span>
                        3D : <span className="righttble_bluetxt">{discountPrize.showDisc3dPrize123 ? discountPrize.showDisc3dPrize123 : 0}%,</span>
                        2D : <span className="righttble_bluetxt">{discountPrize.showDisc2dPrize123 ? discountPrize.showDisc2dPrize123 : 0}%</span>
                      </div> :
                      (game_sub_type === "3DDEPAN" ?
                        <div className="Division_result">
                          {props.t('discount')} :
                          3D : <span className="righttble_bluetxt">{discountPrize.showDisc3dPrize123 ? discountPrize.showDisc3dPrize123 : 0}%,</span>
                        </div> :
                        (game_sub_type === "TwoDDepan" ?
                          <div className="Division_result">
                            {props.t('discount')} :
                            2D : <span className="righttble_bluetxt">{discountPrize.showDisc2dPrize123 ? discountPrize.showDisc2dPrize123 : 0}%</span>
                          </div> :
                          (game_sub_type === "TwoDTengah" ?
                            <div className="Division_result">
                              {props.t('discount')} :
                              2D : <span className="righttble_bluetxt">{discountPrize.showDisc2dPrize123 ? discountPrize.showDisc2dPrize123 : 0}%</span>
                            </div> :
                            (game_sub_type === "5d6d" ?
                              <div className="Division_result">
                                {props.t('discount')} :
                                6D : <span className="righttble_bluetxt"> {discountPrize.showDisc6dPrize123}%, </span>
                                5D : <span className="righttble_bluetxt">{discountPrize.showDisc5dPrize123}%</span>
                              </div> : ''))))) :
                    <div className="Division_result">
                      {props.t('discount')} : 4D : <span className="righttble_bluetxt"> {discountPrize.showDisc4d}%, </span>
                      3D : <span className="righttble_bluetxt">{discountPrize.showDisc3d}%,</span>
                      2D : <span className="righttble_bluetxt">{discountPrize.showDisc2d}%</span>
                    </div>

            }
            {game_sub_type === "POLA_TARUNG" ?
              <div className="Menebak_result">{props.t('prize')} 4D/3D/2D - POLA TARUNG</div>
              :
              <div className="Menebak_result">{props.t('prize')} {game_sub_type == "3DDEPAN" ? "3D DEPAN" : game_sub_type == "TwoDDepan" ? "2D DEPAN" : game_sub_type == "TwoDTengah" ? "2D TENGAH" : (game_sub_type == "4d3d2d" || game_sub_type == "4D3D2D") ? "4D / 3D / 2D"
                : game_sub_type == "5d6d" ? "6D / 5D" : game_sub_type}</div>
            }
            <div className="title-price">
              {game_sub_child_type == "PRIZE" ? (
                <>
                <span className="righttble_whitetxt">
                  {props.t('prize')}:
                  <br />
                  
                  {props.t('prize')} 1: 4D : <span className="righttble_bluetxt">X {discountPrize.showMenang4dPrize123},</span>
                  3D Depan: <span className="righttble_bluetxt">X {discountPrize.showMenang3dDepanPrize123},</span>
                  3D Belakang: <span className="righttble_bluetxt">X {discountPrize.showMenang3dBelakangPrize123},</span>
                  2D Depan: <span className="righttble_bluetxt">X {discountPrize.showMenang2dDepanPrize123},</span>
                  2D Tengah: <span className="righttble_bluetxt">X {discountPrize.showMenang2dTengahPrize123},</span>
                  2D Belakang: <span className="righttble_bluetxt">X {discountPrize.showMenang2dBelakangPrize123}</span>
                  <br /><br />
                  {props.t('prize')} 2: 4D : <span className="righttble_bluetxt">X {discountPrize.showMenang4dPrize123_2},</span>
                  3D Depan: <span className="righttble_bluetxt">X {discountPrize.showMenang3dDepanPrize123_2},</span>
                  3D Belakang: <span className="righttble_bluetxt">X {discountPrize.showMenang3dBelakangPrize123_2},</span>
                  2D Depan: <span className="righttble_bluetxt">X {discountPrize.showMenang2dDepanPrize123_2},</span>
                  2D Tengah: <span className="righttble_bluetxt">X {discountPrize.showMenang2dTengahPrize123_2},</span>
                  2D Belakang: <span className="righttble_bluetxt">X {discountPrize.showMenang2dBelakangPrize123_2}</span>
                  <br /><br />
                  {props.t('prize')} 3: 4D : <span className="righttble_bluetxt">X {discountPrize.showMenang4dPrize123_3},</span>
                  3D Depan: <span className="righttble_bluetxt">X {discountPrize.showMenang3dDepanPrize123_3},</span>
                  3D Belakang: <span className="righttble_bluetxt">X {discountPrize.showMenang3dBelakangPrize123_3},</span>
                  2D Depan: <span className="righttble_bluetxt">X {discountPrize.showMenang2dDepanPrize123_3},</span>
                  2D Tengah: <span className="righttble_bluetxt">X {discountPrize.showMenang2dTengahPrize123_3},</span>
                  2D Belakang: <span className="righttble_bluetxt">X {discountPrize.showMenang2dBelakangPrize123_3}</span>
                  </span></>
              )
                :
                game_sub_child_type == "FULLBET" ?
                  (
                    ((game_sub_type == "4d3d2d" || game_sub_type == "4D3D2D" || game_sub_type == "POLA_TARUNG" || game_sub_type == "BBFS") ?
                      <div className="result-indata"><span className="prize-text">{props.t('prize')}:
                        4D :</span> <span className="righttble_bluetxt">X {discountPrize.showMenang4dFullbet},</span>
                        <span className="trd-belg">3D Belakang:</span> <span className="righttble_bluetxt">X {discountPrize.showMenang3dBelakangFullbet},</span>
                        <span className="td-belg">2D Belakang:</span> <span className="righttble_bluetxt">X {discountPrize.showMenang2dBelakangFullbet}</span></div> :
                      (game_sub_type === "3DDEPAN" ?
                        <div className="result-indata">
                          <span className="trd-belg">{props.t('prize')}: 3D Depan:</span> <span className="righttble_bluetxt">X {discountPrize.showMenang3dDepanFullbet}</span>
                        </div>
                        :
                        (game_sub_type === "TwoDDepan" ?
                          <div className="result-indata">
                            <span className="td-belg">{props.t('prize')}: 2D Depan:</span> <span className="righttble_bluetxt">X {discountPrize.showMenang2dDepanFullbet}</span></div> :
                          (game_sub_type === "TwoDTengah" ?
                            <div className="result-indata">
                              <span className="td-belg">{props.t('prize')}: 2D Tengah:</span> <span className="righttble_bluetxt">X {discountPrize.showMenang2dTengahFullbet}</span></div> : 
                              (game_sub_type === "5d6d" ?
                                <div className="result-indata">
                                  <span className="prize-text"> {props.t('prize')}:
                                    6D :</span> <span className="righttble_bluetxt">X {discountPrize.showMenang6dFullbet},</span>
                                  <span className="trd-belg">5D :</span> <span className="righttble_bluetxt">X {discountPrize.showMenang5dFullbet}</span>
                                </div> : '')))))
                  )
                  :
                  game_sub_child_type == "FULLBET" ?
                    (
                      <>
                        {props.t('prize')}: 4D : <span className="righttble_bluetxt">X {discountPrize.showMenang4dFullbet},</span>
                        3D Depan: <span className="righttble_bluetxt">X {discountPrize.showMenang3dDepanFullbet},</span>
                        3D Belakang: <span className="righttble_bluetxt">X {discountPrize.showMenang3dBelakangFullbet},</span>
                        2D Depan: <span className="righttble_bluetxt">X {discountPrize.showMenang2dDepanFullbet},</span>
                        2D Tengah: <span className="righttble_bluetxt">X {discountPrize.showMenang2dTengahFullbet},</span>
                        2D Belakang: <span className="righttble_bluetxt">X {discountPrize.showMenang2dBelakangFullbet}</span>
                      </>
                    )
                    :
                    (
                      ((game_sub_type == "4d3d2d" || game_sub_type == "4D3D2D" || game_sub_type == "POLA_TARUNG" || game_sub_type == "BBFS") ?
                        <div className="result-indata"><span className="prize-text">{props.t('prize')}:
                          4D :</span> <span className="righttble_bluetxt">X {discountPrize.showMenang4d},</span>
                          <span className="trd-belg">3D Belakang:</span> <span className="righttble_bluetxt">X {discountPrize.showMenang3dBelakang},</span>
                          <span className="td-belg">2D Belakang:</span> <span className="righttble_bluetxt">X {discountPrize.showMenang2dBelakang}</span></div> :
                        (game_sub_type === "3DDEPAN" ?
                          <div className="result-indata">
                            <span className="trd-belg">{props.t('prize')}: 3D Depan:</span> <span className="righttble_bluetxt">X {discountPrize.showMenang3dDepan}</span>
                          </div>
                          :
                          (game_sub_type === "TwoDDepan" ?
                            <div className="result-indata">
                              <span className="td-belg">{props.t('prize')}: 2D Depan:</span> <span className="righttble_bluetxt">X {discountPrize.showMenang2dDepan}</span></div> :
                            (game_sub_type === "TwoDTengah" ?
                              <div className="result-indata">
                                <span className="td-belg">{props.t('prize')}: 2D Tengah:</span> <span className="righttble_bluetxt">X {discountPrize.showMenang2dTengah}</span></div> :
                              (game_sub_type === "5d6d" ?
                                <div className="result-indata">
                                  <span className="prize-text"> {props.t('prize')}:
                                    6D :</span> <span className="righttble_bluetxt">X {discountPrize.showMenang6d},</span>
                                  <span className="trd-belg">5D :</span> <span className="righttble_bluetxt">X {discountPrize.showMenang5d}</span>
                                </div> : '')))))

                    )
              }
            </div>
          </>
        )
      ) : (
        <>
          {
            game_code == 'Colok_Bebas' ?
              <div className="Menebak_result">{props.t('guess_one_4d')}</div>
              : game_code == 'Colok_Bebas_2D' ?
                <div className="Menebak_result">{props.t('guess_two_4d')}</div>
                : game_code == 'Colok_Jitu' ?
                  <div className="Menebak_result">{props.t('guess_one_with_position')}</div>
                  : game_code == 'Colok_Naga' ?
                    <div className="Menebak_result">{props.t('guess_three_4d')}</div>
                    : game_code == 'Fifty_Fifty' ?
                      <div className="Menebak_result">{props.t('5050_text')}</div>
                      : game_code == 'Fifty_Fifty_2D' ?
                        <div className="Menebak_result">{props.t('50502D_text')}</div>
                        : game_code == 'Shio' ?
                          <div className="Menebak_result">{props.t('shio_2d')}</div>
                          : game_code == 'Tengah_Dasar' && (game_sub_type == 'TENGAH' || game_sub_type == 'tengahtepi') ?
                            <div className="Menebak_result">{props.t('tengah_dasar_tengah_text')}</div>
                            : game_code == 'Tengah_Dasar' && game_sub_type == 'DASAR' ?
                              <div className="Menebak_result">{props.t('tengah_dasar_dasar_text')}</div>
                              : game_code == 'Kombinasi' ?
                                <div className="Menebak_result">{props.t('kombinasi_text')}</div>
                                : game_code == 'Silang_Kembang' && game_sub_type == 'silanghomo' ?
                                  <div className="Menebak_result">{props.t('silang_kembang_silang_text')}</div>
                                  : game_code == 'Silang_Kembang' && game_sub_type == 'kembangkempis' ?
                                    <div className="Menebak_result">{props.t('silang_kembang_kembang_text')}</div>
                                    : game_code == 'Macau_Shio' ?
                                      <div className="Menebak_result">{props.t('macau_shio_text')}</div>
                                      : ""
          }
          <div className="Division_result">
            {props.t('discount')}:<span className="righttble_bluetxt"> {discountPrize.showDisc}%</span>
          </div>
          {game_code != 'Fifty_Fifty' && game_code != 'Fifty_Fifty_2D' && game_code != 'Tengah_Dasar' && game_code != 'Silang_Kembang' && game_code != 'Kombinasi' ? (
            <>
              <div className="Menebak_result">{props.t('prize')} {game_code == "Colok_Bebas" ? "COLOK BEBAS" : game_code == "Colok_Bebas_2D" ? "COLOK BEBAS 2D" : game_code == "Colok_Jitu" ? "COLOK JITU" : game_code == "Colok_Naga" ? "COLOK NAGA" : game_code == "Macau_Shio" ? "MACAU SHIO" : game_code.toUpperCase()}</div>
              <div className="Division_result">
                {/* Discount:<span className="righttble_bluetxt"> X {discountPrize.showPrize}</span> */}
                {game_code === 'Colok_Bebas' || game_code === 'Colok_Bebas_2D' || game_code === 'Colok_Jitu' || game_code === 'Colok_Naga'
                  || game_code === 'Macau_Shio' || game_code === 'Shio' ? (
                  <>
                    {props.t('prize')}:<span className="righttble_bluetxt"> X {discountPrize.showPrize}</span>
                  </>
                ) : (
                  <>
                    {props.t('discount')}:<span className="righttble_bluetxt"> X {discountPrize.showPrize}</span>
                  </>
                )}
              </div>
            </>
          )
            :
            (
              <></>
            )
          }
        </>
      )}

      <div className="righttble_table">
        <table>
          {/* <thead className="right-table custom-tooltip-wrapper"> */}
          <thead className="right-table">
            <tr>
              <th>No.</th>
              <th>{props.t('date')}</th>
              <th>{props.t('period')}</th>
              <th>Result</th>
              {prize123Status === 1 && <th>Result2</th>}
              {prize123Status === 1 && <th>Result3</th>}            

            </tr>
            {/* {currentStep === 13 && <CoachMarkPopup/> } */}
          </thead>
          <tbody>
            {last10Result && last10Result.map((row, index) => (
              <tr
                key={index}
                className={index % 2 === 0 ? "even-row" : "odd-row"}
              >
                <td>{++index}</td>
                <td>{row.datetime.split(' ')[0]}</td>
                <td>{row.period}-{discountPrize.game_code}</td>
                <td>{row.number}</td>
                {prize123Status === 1 && <td>{row.number2}</td>}
                {prize123Status === 1 && <td>{row.number3}</td>}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {isInfoResultPopup && (
        <div className="overlay">
          <div className="informasi_popup">
            <button className="informasi_popup-close" onClick={() => setIsInfoResultPopup(false)}>
              <IoMdClose className="btnclose" />
            </button>

            <div className="result_txt">RESULT</div>
            <InformasiResultPopup onClose={closeInformasiResultPopup} />
          </div>
        </div>
      )
      }
    </div >
  );
};

export default withTranslation()(RightTable);
